import React, { useCallback, useEffect } from 'react';
import {
  reelsActions,
  reelsActiveIndexSelector,
  reelsItemsSelector,
  reelsLoadingStatusSelector,
} from '$store/reels';
import { statReachGoal } from '$utils';
import { isBackNavigation } from '$navigation/router';
import { useDispatch, useSelector } from 'react-redux';
import { Reels } from '$core/Reels/Reels';

export const ReelsAll = () => {
  const dispatch = useDispatch();
  const reels = useSelector(reelsItemsSelector);
  const activeIndexInitial = useSelector(reelsActiveIndexSelector);
  const loadingStatus = useSelector(reelsLoadingStatusSelector);

  const loadData = useCallback(() => {
    dispatch(reelsActions.loadReels({ replace: true }));
  }, []);

  const loadReels = useCallback(() => {
    dispatch(reelsActions.loadReels({}));
  }, []);

  const isBack = isBackNavigation();

  useEffect(() => {
    dispatch(reelsActions.loadReels({ replace: !isBack }));
    statReachGoal('reels_visit');
    dispatch(reelsActions.setTabBadge(false));
  }, []);

  return (
    <Reels
      loadData={loadData}
      loadReels={loadReels}
      loadingStatus={loadingStatus}
      reels={reels}
      activeIndexInitial={activeIndexInitial}
    />
  );
};
